<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 10:38:43
 * @LastEditors: whaoo
 * @LastEditTime: 2023-11-09 19:34:42
-->
<template>
    <div>
        <div class="tab_list">
            <div>基本资料</div>
            <div>xxxx</div>
            <div>xxxx</div>
            <div>xxxx</div>
            <div>xxxx</div>
            <div :class="{ active: active_tab == 1 }" @click="toggleTab(1)">设备信息</div>
            <div :class="{ active: active_tab == 2 }" @click="toggleTab(2)">患者数据</div>
        </div>
        <div style="color: red;">以下红框内为webview</div>
        <iframe :src="url + `?bedNumber=${bed}&zoneNumber=113286&inpatientCode=12345&roomNumber=1`" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bed: "",
            active_tab: 1,
            url: '/#/bindDevice',
        };
    },

    mounted() {
        this.bed = this.$route.query.bed
    },

    methods: {
        toggleTab(active) {
            this.active_tab = active
            this.url = active == 1 ? '/#/bindDevice' : "/#/deviceData"
        }
    }
}

</script>

<style  scoped>
.tab_list {
    display: flex;
    justify-content: flex-start;
}

.tab_list div {
    width: 100px;
    height: 40px;
    line-height: 40px;
    border: 1px solid rgb(60, 177, 255);
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}

.active {
    background-color: rgb(60, 177, 255);
    color: #fff;
}

iframe {
    border: 1px solid red;
    width: 100%;
    margin-top: 20px;
    height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/view/bed_detail.vue